import { Button } from "@/components/ui/button";
import { ArrowRight, BookOpen, Brain, Award } from "lucide-react";

const HeroSection = () => {
  const scrollToProducts = () => {
    const element = document.getElementById("products");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="bg-amber-400/20 text-amber-300 px-4 py-2 rounded-full text-sm font-medium">
                Virginia's Premier Learning Lab
              </span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Transform Your Future with
              <span className="block text-amber-400 mt-2">AI-Powered Learning</span>
            </h1>
            
            <p className="text-lg text-blue-100">
              DeepCore Learning Lab offers cutting-edge training, consulting, and educational materials in AI, mathematics, and science. Empower yourself with industry-leading certifications and expert-led content.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-explore-btn"
                onClick={scrollToProducts}
                className="bg-amber-400 hover:bg-amber-500 text-blue-900 font-semibold px-8 py-6 rounded-full text-lg group"
              >
                Explore Courses
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                data-testid="hero-contact-btn"
                onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 rounded-full text-lg"
              >
                Contact Us
              </Button>
            </div>

            <div className="flex flex-wrap gap-8 pt-8">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-amber-400/20 rounded-lg flex items-center justify-center">
                  <BookOpen className="w-6 h-6 text-amber-400" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">500+</div>
                  <div className="text-sm text-blue-200">Learning Hours</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-amber-400/20 rounded-lg flex items-center justify-center">
                  <Brain className="w-6 h-6 text-amber-400" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">AI-Powered</div>
                  <div className="text-sm text-blue-200">Learning Tools</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-amber-400/20 rounded-lg flex items-center justify-center">
                  <Award className="w-6 h-6 text-amber-400" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-white">Certified</div>
                  <div className="text-sm text-blue-200">Programs</div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative w-full h-[500px] bg-gradient-to-br from-blue-800/50 to-blue-900/50 rounded-3xl backdrop-blur-sm border border-blue-700/50 p-8 flex items-center justify-center">
              <img
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&q=80"
                alt="Learning environment"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-amber-400 rounded-2xl flex items-center justify-center shadow-2xl">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-900">4.9</div>
                <div className="text-sm text-blue-900">Rating</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;